export const InfoRow = ({ children }) => {
  return (
    <tr>
      <td colSpan="20" className="info-cell">
        {children}
      </td>
    </tr>
  );
};
